import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EncounterData = {
    _v1: {
        createOrUpdateEncounterData: { method: HttpMethod.POST, path: '/v1/create-or-update-encounter-data' },
    },
};
//# sourceMappingURL=api-def.js.map